<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">{{title}}</h1>
        </section>

        <section id="body">
            <form [formGroup]="addCityForm" (ngSubmit)="saveChanges(addCityForm.value)">
                <mat-card>
                    <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                        <div fxFlex="50">
                            <mat-form-field appearance="outline">
                                <mat-label>Nombre</mat-label>
                                <input matInput formControlName="name" required>
                                <mat-error *ngIf="addCityForm.controls['name'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                                <mat-error *ngIf="addCityForm.controls['name'].hasError('pattern')">
                                    Este campo sólo admite caracteres alfabéticos.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div fxFlex="50">
                            <mat-form-field appearance="outline">
                                <mat-label>Estado</mat-label>
                                <mat-select formControlName="status" required>
                                    <mat-option *ngFor="let option of options" [value]="option.value">
                                        {{option.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="addCityForm.controls['status'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card>
                <br>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-flat-button type="submit" [disabled]="!addCityForm.valid" class="save-changes">GUARDAR
                        CAMBIOS</button>
                        <button routerLink="/city-management" mat-raised-button class="cancel-changes">CANCELAR</button>
                </div>
            </form>
        </section>

    </div>
</div>